module.exports = __webpack_public_path__ + "assets/media/drift_login_splash_title.9411d0b7.svg";